import { Component } from '@angular/core';
import { AuthandregistryService } from '../../service/authandregistry.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-pw-forgotten',
    standalone: false,

    templateUrl: './pw-forgotten.component.html',
    styleUrl: './pw-forgotten.component.scss'
})
export class PwForgottenComponent {
    hidespinner: boolean = true;
    forgottpwForm: FormGroup;

    constructor(
        private authService: AuthandregistryService,
        private fb: FormBuilder,
        private router: Router,
    ) {
        this.forgottpwForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
        });
        // let em = localStorage.getItem('ids_be_loginemail')
        // if (em) {
        //     this.forgottpwForm.patchValue({ email: em });
        //     this.onSubmit();
        // }
    }

    async onSubmit() {
        if (this.forgottpwForm.invalid || !this.forgottpwForm.value.email || this.forgottpwForm.value.email.length === 0) return;
        else {
            this.hidespinner = false;
            let result = await this.authService.doPwForgotten(this.forgottpwForm.value.email);
            this.hidespinner = true;

            if (result === true) {
                this.router.navigate(['/login/password-forgotten-sent']);
            }
        }
    }
}
